export default {"src":"/_next/static/media/ic-save.8cf87c70.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};